import { Pipe, PipeTransform } from '@angular/core';
import { ProjectJobStatusSchema } from '@vmspdb/definitions';
import { AbstractEnumPipe } from './abstract-enum.pipe';

@Pipe({
  name: 'enumProjectJobStatus',
  standalone: false,
})
export class EnumProjectJobStatusPipe
  extends AbstractEnumPipe
  implements PipeTransform
{
  readonly enum = ProjectJobStatusSchema;
}
